import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { SharedModule } from '../shared/shared.module';
import { LayoutShellComponent } from './layout-shell/layout-shell.component';
import { SidebarMenuComponent } from './sidebar-menu/sidebar-menu.component';
import { HeaderComponent } from './header/header.component';

@NgModule({
  declarations: [LayoutShellComponent, SidebarMenuComponent, HeaderComponent],
  imports: [CommonModule, RouterModule, SharedModule],
  exports: [LayoutShellComponent],
})
export class LayoutModule {}
